/**
 * Icon Components
 * 재사용 가능한 SVG 아이콘 컴포넌트
 */
import React from 'react';

interface IconProps {
    width?: number;
    height?: number;
    className?: string;
    fill?: string;
    stroke?: string;
}

export const UserIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 24 24">
        <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
);

export const LockIcon: React.FC<IconProps> = ({ width = 20, height = 20, stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill="none" stroke={stroke} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
);

export const EyeIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 24 24">
        <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
    </svg>
);

export const EyeOffIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 24 24">
        <path d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
);

export const EmailIcon: React.FC<IconProps> = ({ width = 20, height = 20, stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill="none" stroke={stroke} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
);

export const PhoneIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 24 24">
        <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
);

export const ArrowRightIcon: React.FC<IconProps> = ({ width = 20, height = 20, stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill="none" viewBox="0 0 24 24">
        <path d="M13 7l5 5m0 0l-5 5m5-5H6" strokeWidth="2" stroke={stroke} />
    </svg>
);

export const CheckCircleIcon: React.FC<IconProps> = ({ width = 24, height = 24, fill = "none", stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

export const LightningIcon: React.FC<IconProps> = ({ width = 24, height = 24, fill = "none", stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
    </svg>
);

export const ChartBarIcon: React.FC<IconProps> = ({ width = 24, height = 24, fill = "none", stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} viewBox="0 0 24 24" fill={fill} stroke={stroke}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
    </svg>
);

export const BuildingIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 24 24">
        <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
);

export const LoginIcon: React.FC<IconProps> = ({ width = 20, height = 20, stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill="none" stroke={stroke} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 16l4-4m0 0l-4-4m4 4H3m5-4v-1a3 3 0 013-3h7a3 3 0 013 3v10a3 3 0 01-3 3h-7a3 3 0 01-3-3v-1" />
    </svg>
);

export const ArrowRightCircleIcon: React.FC<IconProps> = ({ width = 20, height = 20, stroke = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill="none" stroke={stroke} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

export const ArrowLeftIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
    </svg>
);

export const SaveIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 448 512">
        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>
    </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 512 512">
        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
    </svg>
);

export const PlusCircleIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 512 512">
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/>
    </svg>
);

export const TrashIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 448 512">
        <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
    </svg>
);

export const UploadIcon: React.FC<IconProps> = ({ width = 20, height = 20, fill = "currentColor", className }) => (
    <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 512 512">
        <path d="M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
    </svg>
);
